import React, { PropsWithChildren, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useGroupContext } from "../../../../lib/context/Groups/GroupContext";
import { useOutsideClickDetection } from "../../../../lib/hooks/useOutsideClickDetection";
import { useRouter } from "../../../../lib/hooks/useRouter";
import { useGroupsRequests } from "../../../../api/grpc/permissions/useGroupsRequests";

import { HandleLoadingState } from "../../../shared/HandleLoadingState/HandleLoadingState";
import { Icon } from "../../../shared/Icon/Icon";
import { LoadingBox } from "../../../shared/LoadingBox/LoadingBox";
import { GroupItem } from "./GroupItem";
import { PermissionGroupResponse } from "../../../../api/grpc/permissions/permissions";
import { USERS_GROUPS_ROOT_PATH } from "../../../../lib/routes/routes";

export const GroupTable = ({
  groups,
}: PropsWithChildren<{
  groups: PermissionGroupResponse[];
}>) => {
  const ref = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const { history } = useRouter();
  const { refetchGroups } = useGroupContext();
  const { deletePermissionGroup } = useGroupsRequests();

  useOutsideClickDetection(
    ref,
    () => {
      if (showDropdown) {
        setShowDropdown(false);
      }
    },
    showDropdown
  );

  const handleDeleteGroup = async (id: string) => {
    try {
      setDeleteLoading(true);

      await deletePermissionGroup({ id });

      await refetchGroups();

      toast.success("Group deleted successfully.");
    } catch (error: any) {
      toast.error(error?.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleEditGroup = (id: string) => {
    history.push(`${USERS_GROUPS_ROOT_PATH}/edit/${id}`);
  };

  const handleCreateGroup = () => {
    history.push(`${USERS_GROUPS_ROOT_PATH}/add-group`);
  };

  return (
    <HandleLoadingState
      loading={deleteLoading}
      loadingPlaceholder={<LoadingBox count={3} minHeight={70} />}
    >
      <div className="GroupTable">
        {groups.map(({ id, description, name }) => (
          <GroupItem
            key={id}
            id={id}
            name={name}
            description={description}
            icon="teams_icon_18x18"
            handleDeleteGroup={() => handleDeleteGroup(id)}
            handleEditGroup={() => handleEditGroup(id)}
          />
        ))}

        <div
          ref={ref}
          className="GroupTable__item template"
          onClick={() => handleCreateGroup()}
        >
          <Icon icon="plus-icon-bordered" />
          <h6>Add group</h6>
        </div>
      </div>
    </HandleLoadingState>
  );
};
